import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Profile = _resolveComponent("Profile")!
  const _component_BlockMaxWidthHandler = _resolveComponent("BlockMaxWidthHandler")!

  return (_openBlock(), _createBlock(_component_BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "mb-40",
        innerHTML: _ctx.content.heading
      }, null, 8, _hoisted_1),
      _createVNode(_component_Profile, {
        countries: _ctx.content.countries,
        "confirm-email-settings": _ctx.content.confirmEmailSettings
      }, null, 8, ["countries", "confirm-email-settings"])
    ]),
    _: 1
  }))
}